export default __webpack_public_path__ + "static/media/okara_icon.0b35b09a.svg";